import { ClaimsCenter } from '../../src/components'
import Footers from '../../src/components/Footer'
import Header from '../../src/components/Header'

export default function ClaimsPage() {
  return (
    <>
      <Header />
        <div className="cure-inner-container">
          <ClaimsCenter />
        </div>
      <Footers />
    </>
  )
}
